import moment, { Moment } from "moment-timezone";
import { DateAdapterInterface, UnitType } from "@/libs/dates/DateAdatperInterface";
import { DateInput } from "@/libs/dates/DateAdapterFactory";

export class MomentAdapter implements DateAdapterInterface {
    private instance: Moment;

    constructor(input?: DateInput, locale: string = 'en') {
        this.instance = input
            ? moment(input).tz('America/New_York').locale(locale)
            : moment().tz('America/New_York').locale(locale);
    }

    add(amount: number, unit: UnitType): DateAdapterInterface {
        this.instance.add(amount, unit);
        return this;
    }

    subtract(amount: number, unit: UnitType): DateAdapterInterface {
        this.instance.subtract(amount, unit);
        return this;
    }

    diff(input: DateInput, unit: UnitType = "day", precise: boolean = false): number {
        const comparisonInstance = moment(input).tz('America/New_York');
        return this.instance.diff(comparisonInstance, unit, precise);
    }

    format(formatStr: string): string {
        return this.instance.format(formatStr);
    }

    isValid(): boolean {
        return this.instance.isValid();
    }

    toDate(): Date {
        return this.instance.toDate();
    }
}
